import { Link } from "@material-ui/icons";

export default [
    {
      id: 0,
      name: "Loop To",
      icon: <Link></Link>,
    },
  ];